module.exports = __webpack_public_path__ + "img/phdtxt.aa7a2e77.png";